import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { Mail } from 'lucide-react';

const RegistrationSuccess = () => {
  const { theme } = useTheme();

  return (
    <div 
      className="min-h-screen flex flex-col relative overflow-hidden"
      style={{ backgroundColor: theme.mainPanelBg }}
    >
      {/* Animated Background Overlay */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" 
        style={{ background: `radial-gradient(circle, ${theme.sidebarBg} 20%, transparent 80%)` }}
      />
      
      {/* Content Section */}
      <div className="flex-1 flex flex-col items-center justify-center text-center p-6 relative z-10">
        <div className="mb-8">
          <Mail size={64} style={{ color: theme.buttonBg }} className="mx-auto" />
        </div>
        
        <h1 
          className="text-4xl font-extrabold tracking-wide mb-4"
          style={{ color: theme.mainPanelText }}
        >
          Check Your Email
        </h1>
        
        <div 
          className="bg-opacity-50 rounded-xl p-8 mb-8 max-w-xl"
          style={{ backgroundColor: theme.sidebarBg }}
        >
          <p 
            className="text-lg mb-4"
            style={{ color: theme.mainPanelText }}
          >
            We've sent a verification link to your email address. Please check your inbox and click the link to activate your account.
          </p>
          
          <p 
            className="text-sm opacity-80"
            style={{ color: theme.mainPanelText }}
          >
            If you don't see the email, please check your spam folder.
          </p>
        </div>

        <div className="flex gap-4">
          <Link
            to="/login"
            className="px-6 py-3 rounded-lg font-semibold shadow-md transform hover:scale-105 transition-transform"
            style={{ backgroundColor: theme.buttonBg, color: theme.buttonText }}
          >
            Go to Login
          </Link>
          
          <button
            onClick={() => window.location.href = "https://mail.google.com"}
            className="px-6 py-3 rounded-lg font-semibold border border-solid hover:bg-opacity-20 transition-all"
            style={{ borderColor: theme.buttonBg, color: theme.mainPanelText }}
          >
            Open Gmail
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;